var AgeVerification = {
	_verificationFormSelector: '',
	_checkoutButtonSelector: '',
	_debounce: false,
	_cookieName: "age-verify-cookie",
	_buttonHtml: '',
	_cookie: function(){
		return Cookies.get(this._cookieName);
	},
	_form: null,
	_checkoutButton: null,

	_formData: function(){
		if (this._form.length == 0){
			this._form = jQuery(this._verificationFormSelector);
		}
		return this._form.serializeArray();
	},
	_makePayload: function(){
		var formData = this._formData();
		var payload = {
			"first":(formData[0].value ? formData[0].value : ''),
			"last":(formData[1].value ? formData[1].value : ''),
			"dob":(formData[2].value ? AgeVerification._normalizeDob(formData[2].value) : ''),
			"zip":(formData[3].value ? formData[3].value : ''),
			"ssn4_sum":(formData[4].value ? formData[4].value : '')
		};
		return payload;
	},
	_normalizeDob: function(dobString){
		return dobString.replace(/-/g, '/');
	},
	_hideButton: function(){
		this._checkoutButton.hide();
	},
	_showButton: function(){
		this._checkoutButton.show();
	},
	_setButtonState: function(state){
		if (state === 'disabled'){
			jQuery('#checkout-button').addClass('btn-disabled');
			jQuery('#checkout-button').html('Verifying...');
		}
		if (state === 'enabled'){
			jQuery('#checkout-button').removeClass('btn-disabled');
			jQuery('#checkout-button').html(AgeVerification._buttonHtml);
		}
	},
	reload: function(){
		this.init(this._verificationFormSelector, this._checkoutButtonSelector);
	},

	init: function(verificationForm, checkoutButton){
		
		$('#international-customer').click(function(){
			AgeVerification.bypass();
		});

		//Put our input DOM element into a jQuery Object
		var $jqDate = jQuery('input[name="dob"]');

		//Bind keyup/keydown to the input
		$jqDate.bind('keyup','keydown', function(e){
			
		  //To accomdate for backspacing, we detect which key was pressed - if backspace, do nothing:
			if(e.which !== 8) {	
				var numChars = $jqDate.val().length;
				if(numChars === 2 || numChars === 5){
					var thisVal = $jqDate.val();
					thisVal += '/';
					$jqDate.val(thisVal);
				}
		  }
		});
		
		if (!this.shouldVerify()){
			$('#verify-form-fields').hide();
			$('#international-customer').hide();
			$('#checkout-button').html('Checkout');
			$('#checkout-button').insertAfter('#update-button');
		}

		this._verificationFormSelector = verificationForm;
		this._checkoutButtonSelector = checkoutButton;
		this._form = jQuery(verificationForm);


		this._buttonHtml = jQuery('#checkout-button').html();
		this._checkoutButton = jQuery(checkoutButton);

		//console.log(this);

		if (this.shouldVerify()){
			jQuery(checkoutButton).click(function(event){
				if (!AgeVerification._debounce){
					AgeVerification._debounce = true;
					AgeVerification.verify();
					event.preventDefault();
					return false;
				}
			});
			$('[data-cart-form="cart-form"] [name="ssn4_sum"]').bind('keydown', function(e){
				if (e.keyCode == 13){
					AgeVerification._debounce = true;
					AgeVerification.verify();
					e.preventDefault();
					return false;
				} else {

				}
			})
		} else {
			
		}
		
	},

	bypass: function(){
		Cookies.set(AgeVerification._cookieName, 'verified', { expires: 0 });	// 6 hours.
		$('#checkout-button').unbind('click');
		$('#checkout-button').click();
	},

	shouldVerify: function(){
		if (this._cookie() === undefined){
			return true;
		} 
		return false;
	},

	verify: function(){
		AgeVerification._setButtonState('disabled');
		var self = this;
		jQuery.ajax({
			url: "/apps/verify",
			type: "post",
			dataType: 'json',
			contentType: 'application/json',
			data: this._makePayload(),
		}).done(function(data){
			AgeVerification._debounce = false;
			AgeVerification._setButtonState('enabled');
			// Response, if verified, will return new cartCode.
			if (data == "OK"){
				// Save cookie so that verification doesn't need to happen again for a while
				Cookies.set(AgeVerification._cookieName, 'verified', { expires: 0.25 });	// 6 hours.
				$('#checkout-button').unbind('click');
				$('#checkout-button').click();
			} else {
				jQuery('#error-msg').show();
			}
		});
	},
	

};